
const Truck = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="16"
    fill="none"
    {...props}
    viewBox="0 0 22 16"
  >
    <path
      fill="#155DE9"
      d="M5 16a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 2 13H0V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h14v4h3l3 4v5h-2q0 1.25-.875 2.125A2.9 2.9 0 0 1 17 16a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 14 13H8q0 1.25-.875 2.125A2.9 2.9 0 0 1 5 16m0-2q.424 0 .713-.287A.97.97 0 0 0 6 13a.97.97 0 0 0-.287-.713A.97.97 0 0 0 5 12a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 13q0 .424.287.713Q4.576 14 5 14m12 0q.424 0 .712-.287A.97.97 0 0 0 18 13a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 12a.97.97 0 0 0-.712.287A.97.97 0 0 0 16 13q0 .424.288.713.287.287.712.287m-1-5h4.25L18 6h-2z"
    ></path>
  </svg>
);

export default Truck;
